import posthog from 'posthog-js'

const POSTHOG_API_KEY = import.meta.env.VITE_POSTHOG_API_KEY

export function initPostHog(
  bootstrapFlags?: Record<string, boolean | string>,
): boolean {
  if (typeof window === 'undefined') return false
  if (!POSTHOG_API_KEY) return false

  posthog.init(POSTHOG_API_KEY, {
    api_host: 'https://us.i.posthog.com',
    capture_pageview: false,
    bootstrap: bootstrapFlags ? { featureFlags: bootstrapFlags } : undefined,
  })
  return true
}

export { posthog }
